import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Paper, Typography,
  MenuItem, CircularProgress, TextField, Checkbox,
  FormControlLabel, FormHelperText,
  FormControl, Select, InputLabel, SvgIcon
} from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Container from '@material-ui/core/Container';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { MatExpansionPanel, MatExpansionPanelSummary, MatExpansionPanelDetails } from './components';
import Papa from 'papaparse';
import 'react-datasheet/lib/react-datasheet.css';
import './style.css';
import 'bootstrap/dist/css/bootstrap.css';
import { MyReactDataSheet } from '../../../models';
import { ErrorStatusBar } from '../../../../shared/components';
import { PaginatedResponse } from '../../../../shared/models';
import { BusinessSupplierLinkRecord } from '../../../../master-data/models';
import { getLinkedKoronaBusinessSuppliers } from '../../../../master-data/api';
import { checkStatus, parseJSON, handleError } from '../../../../shared/api/core';
import { EMPTY_ROW_MSG, ERROR_500, ERROR_MSG, NO_PERMISSIONS_ERROR_MSG } from '../../../../shared/lib/Localization';
import { Toast, enqueueSnackbar, ToastSuccess, ToastError } from '../../../../shared/components/Notifier';
import { useStyles } from './styles';
import { GridElement, stockOrderHeaders } from '../../../models';
import moment from 'moment';
import { isInvoiceDocumentUpload } from '../../../../shared/lib/invoiceUploadUtils';

const StockOrderCSVImport = (props: any) => {
  const classes = useStyles({});
  const [definedHeaders, setDefinedHeaders] = useState(stockOrderHeaders);
  const [parserError, setParserError] = useState(false);
  const [parsedCSVData, setParsedCSVData] = useState([]);

  const [emptyDataSourceMessage, setEmptyDataSourceMessage] = useState(EMPTY_ROW_MSG);
  const [isErrorStatusVisible, setErrorStatusVisible] = useState(false);

  const [preFilterCellCount, setPreFilterCellCount] = useState(3);
  const [checkRowsInput, setCheckRowsInput] = useState('');
  const [checkColumnsInput, setCheckColumnsInput] = useState('');
  const [allowRowColSelection, setRowColSelection] = useState(false);
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const panelRef = useRef();
  // const tbodyRef = useRef<React.RefObject<HTMLTableSectionElement>>();

  const {
    parsedPdfData, uploadPDF,
    selectedFile, selectedFileError,
    selectedSupplier, supplierError,
    gridData, setGridData,
    mappedHeaders, setMappedHeaders,
    headersError, uiLoading, setUILoading,
    windowHeight, windowWidth,
  } = props;


  const businessHasInvoiceConfig = () => {
    if (selectedSupplier) {
      const { business_settings } = selectedSupplier.master_company;
      if (business_settings && business_settings.length > 0) {
        const bs = business_settings.find((s: { key: string, value: string; }) => s.key === "INVOICE_HEADER_MAP_CONFIG");
        return bs ? true : false;
      }
    }
    return false;
  };

  const mapHeadersFromConfig = () => {
    let config: any = null;
    // console.log("selectedSupplier", selectedSupplier);
    if (selectedSupplier) {
      const { business_settings } = selectedSupplier.master_company;
      if (business_settings && business_settings.length > 0) {
        const bs = business_settings.find((s: { key: string, value: string; }) => s.key === "INVOICE_HEADER_MAP_CONFIG");
        config = JSON.parse(bs.value);
      }
      if (config) {
        // config.headersOnFirstRow ? setFirstRowHeaders(true) : setFirstRowHeaders(false);
        if (config.columnsToIgnore) {
          setCheckColumnsInput(config.columnsToIgnore);
        }
        if (config.rowsToIgnore) {
          setCheckRowsInput(config.rowsToIgnore);
        }
        if (config.columns) {
          const map = new Map(mappedHeaders);
          Object.keys(config.columns).forEach(k => {
            const header = definedHeaders.find(h => h.toLowerCase() === config.columns[k].toLowerCase());
            if (header) {
              map.set(Number(k), header);
            }
          });
          setMappedHeaders(map);
        }
        setRowColSelection(!allowRowColSelection);
      }
    }
  };

  const expandPanel = (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  useEffect(() => {
    onCheckMultiRowsOrCols('col');
    onCheckMultiRowsOrCols('row');
  }, [allowRowColSelection]);

  useEffect(() => {
    if (props.selectedFile) {
      const fileExtension = props.selectedFile.name.split('.').pop()?.toLowerCase();
      const validExtensions = ['csv', 'tsv', 'txt'];
      if (isInvoiceDocumentUpload(props.selectedFile.name)) {
        uploadPDF();
      } else if (fileExtension && validExtensions.includes(fileExtension)) {
        parseCSV();
      }
    }
  }, [props.selectedFile, props.selectedSupplier]);

  const parseCSV = () => {
    if (props.selectedFile) {
      const CSVParserConfig = {
        complete: function (results: any, file: any) {
          // console.log('results', results)
          // console.log("Finished:", results.data);
          if (results.data.length > 0) {
            // console.log('papa parser', results.data);
            mapCSVDataToGrid(results.data);
            mapHeadersFromConfig();
          }
          setParserError(false);
        },
        dynamicTyping: false,
        error: function (error: any, file: any) {
          console.log("Error occurred while parsing csv!");
          setParserError(true);
        },
        skipEmptyLines: true
      };
      Papa.parse(props.selectedFile, CSVParserConfig);
    }
  };

  const getMappedHeader = (key: number) => {
    if (props.mappedHeaders.get(key)) {
      return props.mappedHeaders.get(key);
    }
    return '';
  };

  const handleChangeMappedHeader = (header: string, key: number) => {
    const map = new Map(mappedHeaders);
    map.set(key, header);
    setMappedHeaders(map);
  };

  const onResetButtonClick = () => {
    // parseCSV();
    setMappedHeaders(new Map<number, string>());
  };
  const onClearCheckedButtonClick = () => {
    // if (selected)
    // parseCSV();
  };

  useEffect(() => {
    if (parsedPdfData) {
      console.log('mapping data', parsedPdfData);
      mapCSVDataToGrid(parsedPdfData);
      mapHeadersFromConfig();
    }
  }, [parsedPdfData]);

  useEffect(() => {
    if (selectedSupplier && selectedFile) {
      mapHeadersFromConfig();
    }
  }, [selectedSupplier]);

  const mapCSVDataToGrid = (data: any[][]) => {
    let result: GridElement[][] = [];
    for (let i = -1; i < data.length; i++) {
      let row = null;
      if (i === -1) {
        row = data[0];
      } else {
        row = data[i];
      }
      let newRow: GridElement[] = [];
      for (let j = -1; j < row.length; j++) {
        const gridElement = { value: '', isSelected: false, isIgnored: false, type: 'data' } as GridElement;
        // if (i === 0) { // row = 1
        //   gridElement.isSelected = isFirstRowHeaders;
        //   gridElement.isIgnored = isFirstRowHeaders;
        // }
        if (i === -1 && j === -1) { // row=0, col=0
          gridElement.type = 'data';
          // gridElement.value = 'Headers'
        } else if (i === -1) { // row=0
          gridElement.type = 'header';
        }
        // } else  if (i === -1 && j === -1) {
        //     gridElement.type = 'data';
        else if (j === -1) { // col=0
          gridElement.type = 'checkbox';
        } else {
          gridElement.type = 'data';
          if (!row[j]) {
            gridElement.value = '';
          } else {
            gridElement.value = row[j];
          }
        }
        newRow.push(gridElement);
      }
      result.push(newRow);
    }
    setGridData(result);
    // console.log('data to be validated', result);
  };

  const setSelectedRowOrColumn = (row: number, column: number, cell: any, isChecked: boolean) => {
    if (row === 0) {
      toggleSelectedColumnInGrid(column, isChecked);
    } else if (column === 0) {
      toggleSelectedRowInGrid(row, isChecked);
    }
  };

  const toggleSelectedColumnInGrid = (col: number, isChecked: boolean) => {
    const grid = gridData.map((row: any[]) => [...row]);
    for (let x = 0; x < grid.length; x++) {
      for (let y = 0; y < grid[x].length; y++) {
        if (y === col) {
          grid[x][y].isSelected = isChecked;
          grid[x][y].isIgnored = isChecked;
          if (grid[x][0].isSelected) { // check if row is already selected
            grid[x][y].isSelected = true;
            grid[x][y].isIgnored = true;
          }
        }
      }
    }
    setGridData(grid);
    // clear the header mapping for this column
    const map = new Map(mappedHeaders);
    map.delete(col);
    setMappedHeaders(map);
  };

  const toggleMultipleColumnsInGrid = (columns: number[], isChecked: boolean) => {
    const grid = gridData.map((row: any[]) => [...row]);
    const map = new Map(mappedHeaders);
    for (let x = 0; x < grid.length; x++) {
      for (let y = 0; y < grid[x].length; y++) {
        if (y === 0) {
          continue;
        }
        if (columns.includes(y)) {
          grid[x][y].isSelected = isChecked;
          grid[x][y].isIgnored = isChecked;
          if (grid[x][0].isSelected) { // check if row is already selected
            grid[x][y].isSelected = true;
            grid[x][y].isIgnored = true;
          }
          // clear the header mapping for this column
          map.delete(y);
        }
      }
    }
    setGridData(grid);
    setMappedHeaders(map);
  };

  const toggleSelectedRowInGrid = (row: number, isChecked: boolean) => {
    const grid = gridData.map((r: any[]) => [...r]);
    for (let x = 0; x < grid.length; x++) {
      for (let y = 0; y < grid[x].length; y++) {
        if (x === row) {
          // if (isFirstRowHeaders && row === 1) {
          //   grid[x][y].isSelected = true;
          //   grid[x][y].isIgnored = true;
          // } else {
          grid[x][y].isSelected = isChecked;
          grid[x][y].isIgnored = isChecked;
          // }
          if (grid[0][y].isSelected) {
            grid[x][y].isSelected = true;
            grid[x][y].isIgnored = true;
          }
        }
      }
    }
    setGridData(grid);
  };

  const toggleMultipleRowsInGrid = (rows: number[], isChecked: boolean) => {
    const grid = gridData.map((row: any[]) => [...row]);
    for (let x = 0; x < grid.length; x++) {
      for (let y = 0; y < grid[x].length; y++) {
        if (rows.includes(x)) {
          // if (isFirstRowHeaders && x === 1) {
          //   grid[x][y].isSelected = true;
          //   grid[x][y].isIgnored = true;
          // } else {
          grid[x][y].isSelected = isChecked;
          grid[x][y].isIgnored = isChecked;
          // }
          if (grid[0][y].isSelected) {
            grid[x][y].isSelected = true;
            grid[x][y].isIgnored = true;
          }
        }
      }
    }
    setGridData(grid);
  };

  const onPreFilterBtnClick = () => {
    const grid = gridData.map((row: any[]) => [...row]);
    const rowsToIgnore = [];
    const filterCellCount = 1;

    if (filterCellCount > 0) {
      for (let row = 0; row < grid.length; row++) {
        if (row === 0) {
          continue;
        }
        if (grid[row][0] && grid[row][0].isSelected) {
          continue;
        }
        let cellCount = 0;
        for (let col = 0; col < grid[row].length; col++) {
          if (grid[row][col].isSelected) {
            // console.log('col is checked:' + 'row: ' + row + ' col: ' + col);
            continue;
          } else {
            const columnHeader = mappedHeaders.get(col);
            // console.log('columnHeader',columnHeader);
            if (columnHeader) {
              const value = grid[row][col].value;
              if (!value.replace(/\s/g, '').length) {
                // console.log('row: ' + row + ' col: ' + col + ' has blank value')
                cellCount++;
              }
            }
          }
          if (cellCount === filterCellCount) {
            // console.log('ignoring row...', row)
            rowsToIgnore.push(row);
            break;
          }
        }
      }
      if (rowsToIgnore.length > 0) {
        toggleMultipleRowsInGrid(rowsToIgnore, true);
      }
    }
  };

  const onCheckMultiRowsOrCols = (type: string) => {
    let input = null;
    if (type === 'col') {
      input = String(checkColumnsInput).trim();
    } else if (type === 'row') {
      input = String(checkRowsInput).trim();
    }
    if (input) {
      if (input.replace(/\s/g, '').length) {
        const inputStringArray = input.split(',');
        const ranges: string[] = [];
        const indices: number[] = [];
        inputStringArray.forEach(string => {
          const s = string.trim();
          if (s.includes('-')) {
            ranges.push(s);
          } else {
            indices.push(Number(s));
          }
        });
        ranges.forEach(r => {
          const rangeSplitArray = r.split('-');
          if (rangeSplitArray.length >= 2) {
            const start = Number(rangeSplitArray[0]);
            const end = Number(rangeSplitArray[1]);
            for (let i = start; i <= end; i++) {
              indices.push(i);
            }
          }
        });
        indices.sort((a, b) => { return a - b; });
        if (type === 'col') {
          toggleMultipleColumnsInGrid(indices, true);
        } else if (type === 'row') {
          toggleMultipleRowsInGrid(indices, true);
        }
      }
    }
  };

  const getTableBodyMaxHeight = () => {
    const style = { maxHeight: 0 };
    if (windowWidth) {
      if (windowWidth >= 2260) {
        style.maxHeight = 900;
      } else if (windowWidth >= 1920) {
        style.maxHeight = 472;
      } else if (windowWidth >= 1600) {
        style.maxHeight = 456;
      } else if (windowWidth >= 1440) {
        style.maxHeight = 372;
      } else if (windowWidth >= 1366) {
        style.maxHeight = 241;
      } else if (windowWidth >= 1280) {
        style.maxHeight = 445;
      } else if (windowWidth >= 1024) {
        style.maxHeight = 245;
      } else if (windowWidth >= 800) {
        style.maxHeight = 245;
      }
      if (expanded === 'panel1') {
        style.maxHeight = style.maxHeight * 0.6;
      }
      return style;
    }
    return style;
  };

  const cellRenderer: React.FC = (props: any) => {
    // console.log(props)
    const classes = useStyles();
    const { row, col, cell } = props;

    let backgroundStyle = props.cell.isSelected ? { backgroundColor: '#eee' } : undefined;

    switch (props.cell.type) {
      case 'header':
        return (
          <td className="action-cell">
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={props.cell.isSelected}
                    onChange={e => setSelectedRowOrColumn(row, col, cell, e.target.checked)}
                    color="primary" />
                }
                label={'C' + col}
              />
              {
                !props.cell.isSelected &&
                <FormControl className={classes.formControl}>
                  <Select
                    value={getMappedHeader(col)}
                    onChange={(event) => handleChangeMappedHeader(String(event.target.value), col)}
                    inputProps={{
                      name: 'header',
                      id: `defined-header-${col}`
                    }}
                  >
                    {
                      definedHeaders && definedHeaders.map((h, i) => {
                        return <MenuItem value={h} key={i}>{h}</MenuItem>;
                      })
                    }
                  </Select>
                </FormControl>
              }
            </div>
            {props.children}
          </td>
        );
      case 'checkbox':
        const rowIndex = row;
        return (
          <td className="action-cell">
            <FormControlLabel
              control={
                <Checkbox
                  checked={props.cell.isSelected}
                  onChange={e => setSelectedRowOrColumn(row, col, cell, e.target.checked)}
                  color="primary" />
              }
              label={'R' + rowIndex}
            />
            {props.children}
          </td>
        );
      case 'data':
        // if (row === 1 && isFirstRowHeaders && props.cell.isSelected) {
        //   backgroundStyle = { backgroundColor: '#bbdefb' };
        // }
        return (
          <td style={{ ...backgroundStyle, width: '1%', whiteSpace: 'nowrap' }}
            onMouseDown={props.onMouseDown}
            onMouseOver={props.onMouseOver}
            className="cell">
            {props.children}
          </td>
        );
    }
    return null;
  };

  return (
    <div>
      <ErrorStatusBar isVisible={isErrorStatusVisible} />
      <Paper className={classes.paper} elevation={0}>
        {
          uiLoading &&
          <div style={{ textAlign: 'center' }}>
            <CircularProgress />
          </div>
        }
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', paddingBottom: 8 }}>
          {
            !selectedFile && selectedFileError.hasError &&
            <div className={classes.textLabel}>
              <Typography variant="body1" className={classes.errorText}>{selectedFileError.message}</Typography>
            </div>
          }
          {
            !selectedFile && !selectedFileError.hasError &&
            <Container maxWidth="sm">
              <div className={classes.textLabel}>
                <Typography variant="h5" className={classes.sectionTitle}>Let's Get Started!</Typography>
                <Typography variant="body1" className={classes.instructions}>1. Select a supplier</Typography>
                <Typography variant="body1" className={classes.instructions}>2. Upload Invoice PDF, PNG, JPEG or TSV file.</Typography>
              </div>
            </Container>
          }
        </div>
        {
          gridData.length > 0 &&
          headersError &&
          headersError.hasError &&
          <div className={classes.actionRow}>
            <div style={{ justifySelf: 'flex-start', alignSelf: 'center', paddingBottom: 8 }}>
              <div>
                <Typography variant="body1" className={classes.errorText}>{headersError.message}</Typography>
                <Typography variant="body1" className={classes.errorText}>{headersError.message2}</Typography>
              </div>
            </div>
          </div>
        }
        {
          gridData.length > 0 &&
          <MatExpansionPanel
            ref={panelRef}
            expanded={expanded === 'panel1'}
            onChange={expandPanel('panel1')}>
            <MatExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className={classes.heading}>Advanced Data Controls</Typography>
            </MatExpansionPanelSummary>
            <MatExpansionPanelDetails>
              <div style={{ padding: '12px 16px', width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: 12, flexWrap: 'wrap' }}>
                  <div style={{ display: 'flex', justifySelf: 'flex-start', alignSelf: 'center', flexWrap: 'wrap' }}>
                    <Typography variant="body1" style={{ paddingRight: 24, fontWeight: 500 }}>Check Rows or Columns to Ignore Data</Typography>
                    <Typography variant="body1" style={{ alignSelf: 'center', fontSize: '0.95rem' }}
                    >(Empty Rows & Columns are automatically ignored.)</Typography>
                  </div>
                </div>
                <div style={{
                  display: 'flex',
                  justifyContent: 'space-around',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  width: '100%'
                }}>
                  <div className={classes.actionCol}>
                    <div className={classes.actionRow}>
                      <div className={classes.actionRow}>
                        <Typography variant="body1" style={{ alignSelf: 'center' }}>Clear Column Mapping</Typography>
                        <div style={{ alignSelf: 'center' }}>
                          <Button variant="contained" style={{ marginLeft: 16 }}>
                            Apply
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className={classes.actionRow}>
                      <div className={classes.actionRow}>
                        <Typography variant="body1" style={{ alignSelf: 'center' }}>Clear All Checks</Typography>
                        <div style={{ alignSelf: 'center' }}>
                          <Button variant="contained"
                            style={{ marginLeft: 16 }}
                            onClick={onClearCheckedButtonClick}>
                            Apply
                      </Button>
                        </div>
                      </div>
                    </div>
                    {
                      businessHasInvoiceConfig() &&
                      <div className={classes.actionRow}>
                        <div className={classes.actionRow}>
                          <Typography variant="body1"
                            style={{ alignSelf: 'center' }}
                          >Reload Saved Column Mapping</Typography>
                          <div style={{ alignSelf: 'center' }}>
                            <Button variant="contained"
                              style={{ marginLeft: 16 }}
                              onClick={mapHeadersFromConfig}>
                              Apply
                        </Button>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  <div className={classes.actionCol}>
                    <div className={classes.actionRow}>
                      <div className={classes.actionRow}>
                        <Typography variant="body1"
                          style={{ alignSelf: 'center' }}
                        >Check All Rows With Missing Required Data</Typography>
                        <div style={{ alignSelf: 'center' }}>
                          <Button variant="contained"
                            className={classes.actionRowBtn}
                            style={{ marginLeft: 16 }}
                            onClick={() => onPreFilterBtnClick()}>
                            Apply
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className={classes.actionRow}>
                      <div className={classes.actionRow}>
                        <TextField
                          id="check-columns"
                          className={classes.textField}
                          value={checkColumnsInput}
                          onChange={(e) => setCheckColumnsInput(e.target.value)}
                          label="Check Columns by Range: 1-3, 6"
                          margin="normal"
                        />
                        <div style={{ alignSelf: 'center' }}>
                          <Button variant="contained"
                            style={{ marginLeft: 16 }}
                            onClick={() => onCheckMultiRowsOrCols('col')}>
                            Apply
                          </Button>
                        </div>
                      </div>
                    </div>
                    <div className={classes.actionRow}>
                      <div className={classes.actionRow}>
                        <TextField
                          id="check-rows"
                          className={classes.textField}
                          value={checkRowsInput}
                          onChange={(e) => setCheckRowsInput(e.target.value)}
                          label="Check Rows by Range: 3-5, 7"
                          margin="normal"
                        />
                        <div style={{ alignSelf: 'center' }}>
                          <Button variant="contained"
                            style={{ marginLeft: 16 }}
                            onClick={() => onCheckMultiRowsOrCols('row')}>
                            Apply
                  </Button>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>




              </div>
            </MatExpansionPanelDetails>
          </MatExpansionPanel>

        }
        {
          gridData.length > 0 &&
          <MyReactDataSheet
            // className={`parsedDataTable ${expanded === 'panel1' ? `expanded` : ''}`}
            data={gridData}
            sheetRenderer={props => (
              <table className={'data-grid parsedDataTable'}>
                <tbody
                  // ref={tbodyRef}
                  style={getTableBodyMaxHeight()}>
                  {props.children}
                </tbody>
              </table>
            )}
            valueRenderer={(cell) => cell.value}
            onCellsChanged={changes => {
              const grid = gridData.map((row: any[]) => [...row]);
              changes.forEach(({ cell, row, col, value }) => {
                grid[row][col] = { ...grid[row][col], value };
              });
              props.setGridData(grid);
            }}
            cellRenderer={cellRenderer} />
        }
      </Paper>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.userLocalData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    showToast: (toast: Toast) => dispatch(enqueueSnackbar(toast))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StockOrderCSVImport);
